<template>
  <v-layout row wrap class="document-upload-table">
    <v-flex xs12 pa-0>
      <template>
        <v-card flat>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left pl-0">Name</th>
                  <th class="document-type-header text-left">Type</th>
                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody v-if="filtered.length > 0">
                <tr v-for="document in filtered" :key="document.id">
                  <td class="pl-0">{{ document.fileName }}</td>
                  <td class="document-type-cell">
                    <v-combobox label="Document Type"
                                :items="typeSelectList"
                                v-model="document.documentTypeId"
                                chips
                                hide-no-data
                                clearable
                                item-text="text"
                                item-value="value"
                                @change="update(document)"
                                :disabled= "isDisabled">
                      <template v-slot:selection="{ item }">
                        <v-chip>
                          {{displayName(item)}}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </td>
                  <td class="text-right pr-0 pl-0">
                    <v-icon style="padding-right: 10px;" color="accent"
                            @click="getDocumentLink(document)">visibility</v-icon>
                    <v-icon v-if="!isDisabled" color="error"
                            @click="deleteDialogForDoc(document)">mdi-trash-can-outline</v-icon>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="3" class="text-center"> No Documents Uploaded</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </template>
    </v-flex>
    <template>
      <v-row justify="center">
        <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline pt-1 pr-1">
              Confirm Deletion
              <v-spacer></v-spacer>
              <v-btn icon @click="deleteConfirmDialog = false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pb-1"> Are you sure you want to delete this document?</v-card-text>
            <v-alert v-if="this.errorDocument !=null" color="error" dark><v-icon size="20" dark>warning</v-icon>{{this.errorDocument}}</v-alert>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn outlined color="error" @click="deleteMethod(deleteDoc)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'DocumentUploadTable',
  props: {
    taskId: {
      type: Number
    },
    stage: {
      type: String,
      default: null
    }
  },
  watch: {
    taskId: function () {
      this.createUploadSingle.workOrderTaskId = this.taskId
    }
  },
  data: () => ({
    // snack bar - single save //TODO SNACKBAR COMPONENT!!!
    timeoutVal: 1000,
    snack_status: false,
    snack_message: null,
    snack_colour: null,
    // snack bar - save all
    updateUploadedFiles: false,
    snack_status_multi: false,
    snack_array: [],
    // delete doc
    deleteDoc: null,
    deleteConfirmDialog: false

  }),
  created () {
    if (!this.task) {
      this.clearDocuments()
    } else {
      // this.createUploadSingle.workOrderTaskId = this.task.id
    }
  },
  methods: {
    ...mapActions({
      loadDocsByTask: 'document/loadDocsByTask',
      updateUploaded: 'document/updateUploadedDocument',
      clearErrors: 'document/clearErrors',
      deleteDocument: 'document/deleteDocument',
      clearDocuments: 'document/clearDocumentTasks',
      documentLink: 'document/getDocLink',
      updateDocument: 'document/updateDocument',
      createDocumentType: 'documentType/createDocumentType',
      restoreDocumentType: 'documentType/restoreDocumentType'
    }),
    deleteDialogForDoc (item) {
      this.clearErrors()
      this.deleteConfirmDialog = true
      this.deleteDoc = item
    },
    async deleteMethod (deleteDoc) {
      await this.deleteDocument(deleteDoc.id)
      if (this.errorDocument == null) {
        this.deleteConfirmDialog = false
        await this.loadDocsByTask(this.task.id)
      } else {
        this.deleteConfirmDialog = true
      }
    },
    async getDocumentLink (doc) {
      await this.documentLink(doc)
    },
    async update (document) {
      if (document.workOrderTask) {
        delete document.workOrderTask
      }

      if (document.documentType) {
        delete document.documentType
      }

      if (typeof document.documentTypeId === 'string') {
        await this.addDocType(document)
      } else if (typeof document.documentTypeId === 'object') {
        document.documentTypeId = document.documentTypeId.value
      }

      await this.updateDocument(document) // update
    },
    async addDocType (document) {
      let exists = false
      let typeId = null
      let archived = false
      let newDoc = {
        name: document.documentTypeId,
        slug: this.slugify(document.documentTypeId)
      }
      this.slugs.forEach((slug) => {
        if (slug.text === newDoc.slug) {
          exists = true
          typeId = slug.value
          archived = slug.archived
        }
      })

      if (exists === false) {
        await this.createDocumentType(newDoc)
        document.documentTypeId = this.docType.id
      } else if (exists === true && archived === false) {
        document.documentTypeId = typeId
      } else {
        await this.restoreDocumentType(typeId)
        document.documentTypeId = typeId
      }
    },
    displayName (value) {
      let val = value
      if (typeof value === 'object') { val = value.value }

      this.typeSelectList.forEach(t => {
        if (t.value === val) {
          val = t.text
        }
      })

      return val
    },
    slugify (name) {
      if (name !== undefined) {
        return name.replace(/\s+/g, '-').toLowerCase()
      }
      return name
    }
  },
  computed: {
    ...mapGetters({
      taskDocuments: 'document/documentsByTask',
      errorDocument: 'document/errorDocument',
      typeSelectList: 'documentType/selectList',
      slugs: 'documentType/slugs',
      users: 'user/usersNoRoles',
      id: 'user/id',
      task: 'workOrderTask/selectedTask',
      docType: 'documentType/documentType',
      userRole: 'user/role'
    }),
    filtered () {
      return this.taskDocuments.filter((document) => {
        if (document.stageCreatedAt === this.stage) {
          return document
        }
      })
    },
    isDisabled () {
      if (this.userRole === 'Sub Foreman' && this.stage !== 'Execution') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
  @media only screen and (max-width: 550px) {
    .document-type-header,
    .document-type-cell {
      display: none;
    }
  }
</style>
